const InitiativeCalculationType = {
	PERCENT_COMPLETE: 'percent-complete',
	BUDGET_SPENT: 'budget-spent',
	SCHEDULE_VARIANCE: 'schedule-variance',
	PERCENT_TIME_ELAPSED: 'percent-time-elapsed',
	BUDGET_REMAINING: 'budget-remaining',
	PROJECTED_BUDGET: 'projected-budget',
	BUDGET_VARIANCE: 'budget-variance',
	BUDGET_VARIANCE_PERCENT: 'budget-variance-percent',
	DAYS_ELAPSED: 'days-elapsed',
	PROJECTED_END_DATE: 'projected-end-date',
	BUDGET: 'budget',
	COLOR: 'color',
	BUDGET_COLOR: 'budget-color',
	SCHEDULE_COLOR: 'schedule-color'
}

// Group all exports at the bottom of the file
export default InitiativeCalculationType

// Export individual INITIATIVE_CALCULATION_TYPE constants
export const {
	PERCENT_COMPLETE,
	BUDGET_SPENT,
	SCHEDULE_VARIANCE,
	PERCENT_TIME_ELAPSED,
	BUDGET_REMAINING,
	PROJECTED_BUDGET,
	BUDGET_VARIANCE,
	BUDGET_VARIANCE_PERCENT,
	DAYS_ELAPSED,
	PROJECTED_END_DATE,
	BUDGET,
	COLOR,
	BUDGET_COLOR,
	SCHEDULE_COLOR
} = InitiativeCalculationType
InitiativeCalculationType.__filename__ = 'initiatives/initiative-calculation-type.js'
